import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const KnowledgeBaseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "KnowledgeBase",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.47 8c-.27-.86-.86-1.59-1.63-2.04a7.6 7.6 0 0 0-4.35-1.44c-2.36.15-4.63 1.01-6.48 2.48l-.15-.19a9.54 9.54 0 0 0-6.09-2.29c-1.76 0-3.49.5-4.98 1.44-.72.48-1.21 1.24-1.36 2.09-1.16.29-1.41.99-1.41 2.61v13.11a2.98 2.98 0 0 0 3.17 2.75h8.85c.29.6.9.98 1.56.98h.85c.67 0 1.27-.37 1.56-.98h8.85c1.63.1 3.04-1.12 3.16-2.75V10.66c0-1.67-.24-2.38-1.53-2.65ZM6.8 23.25c-2.23.72-2.31.53-2.31-1.74V9.12a1.9 1.9 0 0 1 1.06-1.81c3.78-2.47 7.96-.67 9.72.79v15.87l-.17-.07c-2.64-1.07-5.09-1.7-8.29-.66Zm18.37 0c-2.98-1.41-6.75 0-8.24.66-.08.04-.17.07-.26.09V8.13c1.56-1.17 5.25-3.61 9.68-.83.71.31 1.16 1.03 1.12 1.81v12.91c.02 1.72 0 2.31-2.28 1.24Z"
    })
  }));
};